import type { LucideIcon } from "lucide-react";
import {
  CreditCard,
  Banknote,
  Wallet,
  Landmark,
  Smartphone,
  Gift,
  HandCoins,
  Coins,
  PiggyBank,
  ArrowRightLeft,
  CircleDollarSign,
  Receipt,
  ShoppingCart,
  Store,
  Truck,
  Bus,
  Home,
  Heart,
  GraduationCap,
  Briefcase,
} from "lucide-react";
import { cn } from "@repo/share-log-web-utils";

export interface MethodIconInfo {
  name: string;
  icon: LucideIcon;
  label: string;
}

export const METHOD_ICONS: MethodIconInfo[] = [
  { name: "CreditCard", icon: CreditCard, label: "카드" },
  { name: "Banknote", icon: Banknote, label: "현금" },
  { name: "Wallet", icon: Wallet, label: "지갑" },
  { name: "Landmark", icon: Landmark, label: "은행" },
  { name: "Smartphone", icon: Smartphone, label: "모바일" },
  { name: "Gift", icon: Gift, label: "선물" },
  { name: "HandCoins", icon: HandCoins, label: "급여" },
  { name: "Coins", icon: Coins, label: "동전" },
  { name: "PiggyBank", icon: PiggyBank, label: "저축" },
  { name: "ArrowRightLeft", icon: ArrowRightLeft, label: "이체" },
  { name: "CircleDollarSign", icon: CircleDollarSign, label: "달러" },
  { name: "Receipt", icon: Receipt, label: "영수증" },
  { name: "ShoppingCart", icon: ShoppingCart, label: "쇼핑" },
  { name: "Store", icon: Store, label: "매장" },
  { name: "Truck", icon: Truck, label: "배달" },
  { name: "Bus", icon: Bus, label: "교통" },
  { name: "Home", icon: Home, label: "주거" },
  { name: "Heart", icon: Heart, label: "기부" },
  { name: "GraduationCap", icon: GraduationCap, label: "교육" },
  { name: "Briefcase", icon: Briefcase, label: "비즈니스" },
];

const iconMap = new Map(METHOD_ICONS.map((info) => [info.name, info.icon]));

export function getMethodIcon(name: string): LucideIcon | undefined {
  return iconMap.get(name);
}

interface MethodIconProps {
  name: string;
  className?: string;
}

export function MethodIcon({ name, className }: MethodIconProps) {
  const Icon = getMethodIcon(name);
  if (!Icon) return null;
  return <Icon className={cn("h-3.5 w-3.5", className)} />;
}
